import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconMaximize: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M6.97938 3.1875H3.18771V6.97917M12.8127 9.02083V12.8125H9.02105M3.63889 3.63867L6.97938 6.97917M9.02105 9.02083L12.3616 12.3614"
                        stroke="currentColor"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M8.83358 4.5H4.50024V8.83333M15.5002 11.1667V15.5H11.1669M5.01587 5.01563L8.83358 8.83333M11.1669 11.1667L14.9846 14.9844"
                        stroke="currentColor"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M10.6878 5.8125H5.81277V10.6875M18.1878 13.3125V18.1875H13.3128M6.39285 6.39258L10.6878 10.6875M13.3128 13.3125L17.6077 17.6075"
                        stroke="currentColor"
                        strokeWidth="1.35"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
    }
};
